/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const CL_REGION_LOAD = "CL_REGION_LOAD";
export const CL_REGION_LOAD_SUCCESS = "CL_REGION_LOAD_SUCCESS";
export const CL_REGION_LOAD_FAILURE = "CL_REGION_LOAD_FAILURE";

export const GEO_DATA_LOAD = "GEO_DATA_LOAD";
export const GEO_DATA_LOAD_SUCCESS = "GEO_DATA_LOAD_SUCCESS";
export const GEO_DATA_LOAD_FAILURE = "GEO_DATA_LOAD_FAILURE";
